import * as React from 'react';

interface TabPanelProps {
  currentTabIndex: number;
  index: number;
}

export const TabPanel: React.SFC<TabPanelProps> = ({
  children,
  currentTabIndex,
  index,
}) => <div hidden={currentTabIndex !== index}>{children}</div>;

export default TabPanel;
